import { useState } from 'react';
import { AccountTabs, Disburse, Payment, Transactions, LoanBalance, PaymentHistory, Button } from "../../../components";
import { authStaff } from '../../../utils/constants';
import useConfigOptions from '../../../hooks/useConfigOptions';
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../../../slices/staffSlice';
import { fetchRequests } from '../../../Requests/getRequests';
import { show } from '../../../slices/toastSlice';
import { useNavigate } from 'react-router-dom';

function Index({ loan }) {

    const facilityLetter = "Proceed to Files tab to upload signed facility letter";
    const facilityLetterUploaded = "Confirm signed facility letter";
    const disburseLoan = "Confirm loan amount and other details to disburse";
    const activeLoan = "Add a loan payment transaction";

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loanStatesOld } = useConfigOptions();
    const [approveProcess, setApproveProcess] = useState(false);
    const [disapproveProcess, setDisapproveProcess] = useState(false);

    const approveLoanRequest = async(e) => {
        e.preventDefault();
        setApproveProcess(true);

        let url = `/loans/staff/confirm-facility-letter`;
        let headers = authStaff(accessToken);
        let data = {
            _id : loan._id,
            type : loan.type.toLowerCase(),
        }

        let res = await fetchRequests(url, "put", headers, {}, data);

        if(res?.code === 401){
            // clear local storage and redirect to login
            sessionStorage.clear();
			navigate("/login");
            dispatch(show({
                type : "error",
                state : true,
                message : "Your session has expired. Please login to continue."
            }))
            return;
        }
        if(res?.err){
            dispatch(show({
                type : "error",
                state : true,
                message : res?.err
            }))
            return;
        } else {
            dispatch(show({
                type : "success",
                state : true,
                message : `${res?.message}`
            }))
            setTimeout(() => {
                window.location.reload();
            },1500)
        }

        setApproveProcess(false);
    }

    const rejectLoanRequest = async(e) => {
        e.preventDefault();
        setDisapproveProcess(true);

        setTimeout(() => {
            setDisapproveProcess(false);
        })
    }

    const nextAction = loan?.state === loanStatesOld.approved && loan?.facilityLetterUploaded && !loan?.facilityLetterApproved
        ? facilityLetterUploaded
        : loan?.state === loanStatesOld.approved && !loan?.facilityLetterUploaded
            ? facilityLetter
            : loan?.state === loanStatesOld.approved && loan?.facilityLetterUploaded && loan?.facilityLetterApproved
                ? disburseLoan
                : activeLoan;

    return (
        <div className='application-content'>
            <div className='space-y-5 py-4'>

                {/* status of the loan */}
                <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
                    <div className="px-5 py-3.5 border-b border-gray-100 dark:border-gray-700 flex items-center justify-between gap-3">
                        <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-200">Status — Loan application approved</h4>
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-medium bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400 border border-emerald-100 dark:border-emerald-500/20">
                            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
                            Approved
                        </span>
                    </div>
                    <div className="px-5 py-5">
                        <p className="text-xs uppercase tracking-wide font-semibold text-gray-400 dark:text-gray-500 mb-1.5">Next Action</p>
                        <p className="text-base text-gray-700 dark:text-gray-200">{nextAction}</p>
                    </div>
                </div>

                {loan?.state === loanStatesOld.approved && loan?.facilityLetterUploaded && !loan?.facilityLetterApproved && (
                    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
                        <div className="px-5 py-3.5 border-b border-gray-100 dark:border-gray-700">
                            <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-200">Approval Decision</h4>
                        </div>
                        <form className="px-5 py-5 space-y-5">
                            <div>
                                <label htmlFor="comment" className='form-label'>
                                    Comments
                                </label>
                                <textarea name="comment" id="comment" cols="30" rows={4} className="form-textarea" placeholder="Add any notes about this approval (optional)"></textarea>
                            </div>

                            <div className='flex items-center gap-3'>
                                <Button
                                    btnText="Approve"
                                    btnType="button"
                                    btnClasses="form-button w-auto"
                                    processing={approveProcess}
                                    btnFunction={approveLoanRequest}
                                />

                                <Button
                                    btnText="Reject"
                                    btnType="button"
                                    btnClasses="form-button-default w-auto"
                                    processing={disapproveProcess}
                                    btnFunction={rejectLoanRequest}
                                />
                            </div>
                        </form>
                    </div>
                )}
                {/* end status of the loan */}

                {/* disbursement of the loan */}
                {loan?.state === loanStatesOld.approved && loan?.facilityLetterApproved && 
                    <Disburse 
                        loan={loan}
                    />
                }
                {/* end disbursement of the loan */}

                {/* payment of loan */}
                {loan?.state === loanStatesOld.active && 
                <>
                    <Payment 
                        loan={loan}
                    />

                    <AccountTabs 
                        loan={loan}
                    />

                    <LoanBalance loan={loan} />

                    <Transactions loan={loan} />

                    <PaymentHistory loan={loan} />
                </>
                }
                {/* end payment of loan */}

            </div>
        </div>
    )
}

export default Index